/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiDefApiConfiguration } from '../api-def-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { tryItGetRequestHistory } from '../fn/try-it/try-it-get-request-history';
import { TryItGetRequestHistory$Params } from '../fn/try-it/try-it-get-request-history';
import { tryItProxyRequest } from '../fn/try-it/try-it-proxy-request';
import { TryItProxyRequest$Params } from '../fn/try-it/try-it-proxy-request';
import { ApiDefTryItRequestData } from '../models/api-def-try-it-request-data';


/**
 * Operations related to the TryIt feature
 */
@Injectable({ providedIn: 'root' })
export class TryItService extends BaseService {
  constructor(config: ApiDefApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tryItGetRequestHistory()` */
  static readonly TryItGetRequestHistoryPath = '/tryIt';

  /**
   * Get the request history.
   *
   * Retrieve the history of requests made through the TryIt feature.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tryItGetRequestHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  tryItGetRequestHistory$Response(params?: TryItGetRequestHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'requests'?: Array<ApiDefTryItRequestData>;
}>> {
    return tryItGetRequestHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the request history.
   *
   * Retrieve the history of requests made through the TryIt feature.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tryItGetRequestHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tryItGetRequestHistory(params?: TryItGetRequestHistory$Params, context?: HttpContext): Observable<{
'requests'?: Array<ApiDefTryItRequestData>;
}> {
    return this.tryItGetRequestHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'requests'?: Array<ApiDefTryItRequestData>;
}>): {
'requests'?: Array<ApiDefTryItRequestData>;
} => r.body)
    );
  }

  /** Path part for operation `tryItProxyRequest()` */
  static readonly TryItProxyRequestPath = '/tryIt';

  /**
   * Proxy request to test an external API endpoint.
   *
   * Sends a bounded HTTP request to a public endpoint after organization/project authorization.
   * Targets are DNS-validated and connection-pinned; redirects are not followed. Caller Authorization,
   * Cookie, proxy, hop-by-hop, forwarding, and platform headers are stripped pending an explicit
   * credential-forwarding product policy.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tryItProxyRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tryItProxyRequest$Response(params: TryItProxyRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefTryItRequestData>> {
    return tryItProxyRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Proxy request to test an external API endpoint.
   *
   * Sends a bounded HTTP request to a public endpoint after organization/project authorization.
   * Targets are DNS-validated and connection-pinned; redirects are not followed. Caller Authorization,
   * Cookie, proxy, hop-by-hop, forwarding, and platform headers are stripped pending an explicit
   * credential-forwarding product policy.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tryItProxyRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tryItProxyRequest(params: TryItProxyRequest$Params, context?: HttpContext): Observable<ApiDefTryItRequestData> {
    return this.tryItProxyRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefTryItRequestData>): ApiDefTryItRequestData => r.body)
    );
  }

}
